import { render, staticRenderFns } from "./previewPDF.vue?vue&type=template&id=b99a0b44"
import script from "./previewPDF.vue?vue&type=script&lang=js"
export * from "./previewPDF.vue?vue&type=script&lang=js"
import style0 from "./previewPDF.vue?vue&type=style&index=0&id=b99a0b44&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports